// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as enums from '@trialcard/enums';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';


export enum ClsModelsEnumsServiceType {
    Appeal = 'Appeal',
    AePcCase = 'AE/PC Case',
    AlternativeFunding = 'Alternative Funding',
    Adherence = 'Adherence',
    Bi = 'BI',
    Bridge = 'Bridge',
    ClinicalSupport = 'Clinical Support',
    CoPay = 'Co-pay',
    FreeTrialOffer = 'Free Trial Offer',
    InjectionTrainingAdministrationTraining = 'Injection Training (Administration Training)',
    Pap = 'PAP',
    PharmacyReferral = 'Pharmacy Referral',
    PriorAuthorization = 'Prior Authorization',
    ProviderSupport = 'Provider Support',
    QuickBi = 'QuickBI',
    QuickStart = 'QuickStart',
    WelcomeCall = 'Welcome Call',
    WelcomeKit = 'Welcome Kit'
}
